import { render } from "./FormGroupInput.vue?vue&type=template&id=a005c568"
import script from "./FormGroupInput.vue?vue&type=script&lang=js"
export * from "./FormGroupInput.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp8\\htdocs\\AI4IRGClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__